import { takeLatest, put, call, select } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { SAVE_SLIDE, SAVE_SLIDE_FAIL, SAVE_SLIDE_SUCCESS, SaveSlideAction } from '../redux/manageSlidesReducer'
import { Slide } from '../types'
import { RootReducer } from '../redux/rootReducer'

function* UpdateSlideFlow(action: SaveSlideAction): Generator<any, void, any> {
  try {
    const slideId = yield select((state: RootReducer) => state.manageSlidesReducer.activeSlide?.id)
    const response: Slide = yield call(apiCall, {
      endpoint: `/tutors/slides/${slideId}`,
      method: 'PUT',
      params: {
        html: yield select((state: RootReducer) => state.manageSlidesReducer.activeSlide?.html)
      }
    })

    yield put(SAVE_SLIDE_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, slide: response }))
  } catch (error) {
    yield put(SAVE_SLIDE_FAIL())
    console.log(error)
  }
}

export default function* UpdateSlideSaga(): Generator<any, void, any> {
  yield takeLatest([SAVE_SLIDE], UpdateSlideFlow)
}
